import { AxiosInstance } from 'axios';
import { simulate } from './utils';
import { GroupReferralClick } from 'referral-types';

export const baseEndpoint = 'group-referral-click';

export class GroupReferralClickApi {
  private apiInstance: AxiosInstance;

  constructor(apiInstance: AxiosInstance) {
    this.apiInstance = apiInstance;
  }

  async createGroupReferralClick(groupReferralId: string): Promise<GroupReferralClick | null> {
    await simulate();
    const response = await this.apiInstance.post(`/${groupReferralId}`);

    return response.data;
  }
}
